<script setup>
import {ref, computed} from 'vue'
import moment from "moment/moment"
import {useFormStore} from '@/stores/form'
import api from '@/services/api'

// Component Imports
import Button from "@/common/Button.vue"
import FormControlPlainText from "@/common/form-control/FormControlPlainText.vue"

// Props Definition
const props = defineProps({
    formId: String,
    field: Object,
    currentData: Object,
    value: String
})

// Dynamic Pinia Form Store
const formStore = useFormStore(props.formId)

// State
const isDisabled = ref(false)

// Computed Properties
const lastSent = computed(() => {
    return props.currentData[props.field.name] || ''
})

const dateStr = computed(() => {
    return lastSent.value ? moment(lastSent.value).format('DD MMM YYYY, HH:mm') : ''
})

const partyBookingId = computed(() => {
    return props.currentData.id
})

// Methods
const resendEmail = async () => {
    isDisabled.value = true

    try {
        const o = await api.post('api/odp/send-party-booking-email', {
            partyBookingId: partyBookingId.value
        })

        const newDatetime = o.data.partyBooking.resendEmail

        formStore.presetData({
            name: props.field.name,
            value: newDatetime
        })
    } catch (err) {
        // Handle error if needed
    } finally {
        isDisabled.value = false
    }
}
</script>

<template>
    <div>
        <FormControlPlainText :form-id="formId" class="small">
            Email sent:
            <span v-if="lastSent">{{ dateStr }}</span>
            <em v-else>never</em>
        </FormControlPlainText>

        <Button @click="resendEmail" :disabled="isDisabled" class="border">
            Send receipt
        </Button>
    </div>
</template>